module.exports = __webpack_public_path__ + "img/9788992711159.d17ce404.jpg";